import { render, staticRenderFns } from "./ODTemplatesView.vue?vue&type=template&id=9be54640"
import script from "./ODTemplatesView.vue?vue&type=script&lang=js"
export * from "./ODTemplatesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports